module.exports = __webpack_public_path__ + "img/1513410527.cee86766.jpg";